module.exports = __webpack_public_path__ + "site/img/69.56fa33de.jpg";